import { render, staticRenderFns } from "./EditCourseLessons.vue?vue&type=template&id=eff559b8&scoped=true"
import script from "./EditCourseLessons.vue?vue&type=script&lang=js"
export * from "./EditCourseLessons.vue?vue&type=script&lang=js"
import style0 from "./EditCourseLessons.vue?vue&type=style&index=0&id=eff559b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff559b8",
  null
  
)

export default component.exports